import { ARBITRUM, BSC, AVALANCHE_FUJI } from "config/chains";
import arbitrum from "img/ic_arbitrum_24.svg";
import bsc from "img/ic_bsc_24.svg";

import moneyIcon from "img/ic_money_40.svg";
import moneyOutlineIcon from "img/ic_moneyv1flat.svg";
import mlpIcon from "img/ic_mlp_40.svg";
import esMONEYIcon from "img/ic_esmoney_40.svg";
import esMONEYArbitrumIcon from "img/ic_esmoney_arbitrum.svg";
import esMONEYRonIcon from "img/ic_esmoney_bsc.svg";
import gmIcon from "img/gm_icon.svg";
import gmArbitrum from "img/ic_gm_arbitrum.svg";
import gmRon from "img/ic_gm_ron.svg";
import moneyArbitrum from "img/ic_money_arbitrum.svg";
import moneyRon from "img/ic_money_ron.svg";
import mlpArbitrum from "img/ic_mlp_arbitrum.svg";
import mlpRon from "img/ic_mlp_bsc.svg";
import glvIcon from "img/ic_glv_40.svg";

type ChainIcons = {
  network?: string;
  money: string;
  mlp: string;
  esmoney?: string;
  gm: string;
  moneyOutline?: string;
  glv?: string;
};

const ICONS: Record<number | "common", ChainIcons> = {
  [ARBITRUM]: {
    network: arbitrum,
    money: moneyArbitrum,
    mlp: mlpArbitrum,
    esmoney: esMONEYArbitrumIcon,
    gm: gmArbitrum,
  },
  [BSC]: {
    network: bsc,
    money: moneyRon,
    mlp: mlpRon,
    esmoney: esMONEYRonIcon,
    gm: gmRon,
  },
  common: {
    money: moneyIcon,
    moneyOutline: moneyOutlineIcon,
    mlp: mlpIcon,
    esmoney: esMONEYIcon,
    gm: gmIcon,
    glv: glvIcon,
  },
};

export function getIcon(chainId: number | "common", label: keyof ChainIcons) {
  if (!chainId || !(chainId in ICONS)) {
    throw new Error(`No icons found for chain: ${chainId}`);
  }

  return ICONS[chainId][label];
}
export function getIcons(chainId: number | "common") {
  if (!chainId || !(chainId in ICONS)) {
    throw new Error(`No icons found for chain: ${chainId}`);
  }

  return ICONS[chainId];
}
